import { Typography, MediaImageStandard } from 'components/Contentful'
import { Button } from '@achieve/ascend'
import { AchieveLink } from '@/components/AchieveLink'

function NegativeEquityUpdated({ equityImage, negativeEquityTitleSubtitle, negativeEquityConfig }) {
  const onButtonClick = (link = '') => {
    window.location.href = link
  }

  return (
    <div className="ml-4 mr-4 mt-4 lg:mr-0 lg:mt-0 lg:ml-12 bg-white flex flex-col border-2 border-solid rounded-[10px] border-[#D2E2FE] h-full w-90% justify-center items-center">
      <div className="mt-8">
        <MediaImageStandard
          className="h-[200px] w-[200px]"
          alt={equityImage.altText}
          content={equityImage.mediaContent}
          layout="fit"
        />
      </div>
      <div className="flex justify-center flex-col">
        {negativeEquityTitleSubtitle && (
          <Typography
            content={negativeEquityTitleSubtitle?.headline}
            variant="displayMd"
            mobileVariant="headingMd"
            responsive={true}
            data-testid="heloc-title"
            className="pr-6 pl-6 items-center justify-center flex"
          />
        )}
        {negativeEquityTitleSubtitle.subheadline && (
          <Typography
            content={negativeEquityTitleSubtitle?.subheadline}
            variant="bodyLg"
            mobileVariant="bodySm"
            responsive={true}
            data-testid="heloc-sub-title"
            className="mt-4 pr-2 pl-2 items-center justify-center flex"
          />
        )}
      </div>
      <div className="mb-8 mt-8">
        <AchieveLink onClick={() => onButtonClick(negativeEquityConfig?.buttons?.explore?.href)}>
          <Typography
            variant="displayXs"
            fontWeight="bold"
            content={negativeEquityConfig?.buttons?.explore?.title || 'Explore debt solutions'}
          />
        </AchieveLink>
      </div>

      <Typography
        content={
          "The recommendations are just estimates and not an official loan offer. Payment details don't include taxes or insurance. APRs and other information may change."
        }
        variant="bodyXs"
        fontWeight="regular"
        className="py-2 sm:py-6 px-2 sm:px-16 text-[#5C708A]"
      />
    </div>
  )
}

function NegativeEquityInitial({ negativeEquityTitleSubtitle, negativeEquityConfig }) {
  const phoneIconUrl = '/multi-site-assets/icon-phone.svg'

  const onButtonClick = (link = '') => {
    window.location.href = link
  }

  const callToAssociatedNumber = () => {
    if (negativeEquityConfig?.buttons?.call?.phone)
      window.open(`tel:${negativeEquityConfig?.buttons?.call?.phone}`, '_self')
  }

  return (
    <div className="flex flex-col text-center">
      {negativeEquityTitleSubtitle && (
        <Typography
          content={negativeEquityTitleSubtitle?.headline}
          variant="displayLg"
          mobileVariant="headingMd"
          responsive={true}
          data-testid="heloc-title"
          className="pb-2 pt-12 px-5 lg:px-[268px] lg:pt-16 lg:pb-4 text-2xl lg:text-3xl"
        />
      )}
      {negativeEquityTitleSubtitle.subheadline && (
        <Typography
          content={negativeEquityTitleSubtitle?.subheadline}
          variant="bodyLg"
          mobileVariant="bodySm"
          responsive={true}
          data-testid="heloc-sub-title"
          className="pb-5 text-sm lg:text-lg"
        />
      )}
      <div className="flex flex-col justify-center items-center mb-2">
        <Button
          color="primary"
          variant="contained"
          className="w-60 flex flex-row gap-2 mb-8 lg:mb-6"
          size="small"
          onClick={() => onButtonClick(negativeEquityConfig?.buttons?.explore?.href)}
        >
          <Typography
            variant="displayXs"
            fontWeight="bold"
            content={negativeEquityConfig?.buttons?.explore?.title || 'Explore debt solutions'}
          />
        </Button>
        <Button
          color="secondary"
          variant="contained"
          className="w-60 flex flex-row gap-2 mb-8 lg:mb-12"
          size="small"
          onClick={() => callToAssociatedNumber()}
        >
          <MediaImageStandard
            className="object-contain relative"
            alt={'phone icon'}
            height={20}
            content={{ url: phoneIconUrl }}
            width={20}
            layout="fill"
          />
          <Typography
            variant="displayXs"
            fontWeight="bold"
            content={negativeEquityConfig?.buttons?.call?.title || 'Call us'}
          />
        </Button>
      </div>
    </div>
  )
}

export { NegativeEquityUpdated, NegativeEquityInitial }
